import React from 'react';
import styles from './InviteUsersIcon.module.css';

export const InviteUsersIcon = () => (
  <div className={styles.iconContainer}>
    <svg
      width="320"
      height="240"
      viewBox="0 0 320 240"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.inviteIcon}
    >
      {/* Background gradient */}
      <rect
        width="320"
        height="240"
        fill="url(#backgroundGradient)"
        rx="20"
      />

      {/* Main envelope */}
      <g className={styles.envelope}>
        <rect
          x="110"
          y="100"
          width="100"
          height="70"
          rx="8"
          fill="url(#envelopeGradient)"
          stroke="rgba(255, 255, 255, 0.2)"
          strokeWidth="1"
        />
        <path
          d="M 110 108 L 160 140 L 210 108"
          stroke="rgba(255, 255, 255, 0.8)"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      {/* People icons */}
      <g className={styles.people}>
        {/* Left person */}
        <g transform="translate(60, 80)">
          <circle cx="0" cy="0" r="12" fill="url(#person1Gradient)" />
          <rect x="-10" y="12" width="20" height="25" rx="10" fill="url(#person1Gradient)" />
        </g>

        {/* Center person */}
        <g transform="translate(160, 60)">
          <circle cx="0" cy="0" r="14" fill="url(#person2Gradient)" />
          <rect x="-12" y="14" width="24" height="30" rx="12" fill="url(#person2Gradient)" />
        </g>

        {/* Right person */}
        <g transform="translate(260, 80)">
          <circle cx="0" cy="0" r="12" fill="url(#person3Gradient)" />
          <rect x="-10" y="12" width="20" height="25" rx="10" fill="url(#person3Gradient)" />
        </g>
      </g>

      {/* Connection lines */}
      <g className={styles.connections}>
        <path
          d="M 72 95 Q 90 85 148 75"
          stroke="url(#connectionGradient)"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          strokeDasharray="4 4"
          opacity="0.6"
        />
        <path
          d="M 172 75 Q 210 85 248 95"
          stroke="url(#connectionGradient)"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          strokeDasharray="4 4"
          opacity="0.6"
        />
      </g>

      {/* Send icon */}
      <g className={styles.sendIcon} transform="translate(240, 130)">
        <circle cx="0" cy="0" r="16" fill="url(#sendIconGradient)" />
        <path
          d="M -6 0 L 6 0 M 3 -3 L 6 0 L 3 3"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      {/* Decorative elements */}
      <g className={styles.decorative} opacity="0.3">
        <circle cx="50" cy="50" r="3" fill="#06b6d4" />
        <circle cx="270" cy="60" r="2" fill="#3b82f6" />
        <circle cx="80" cy="200" r="2" fill="#10b981" />
        <circle cx="240" cy="200" r="3" fill="#8b5cf6" />
      </g>

      <defs>
        <linearGradient id="backgroundGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(6, 182, 212, 0.05)" />
          <stop offset="100%" stopColor="rgba(59, 130, 246, 0.05)" />
        </linearGradient>

        <linearGradient id="envelopeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f59e0b" />
          <stop offset="100%" stopColor="#d97706" />
        </linearGradient>

        <linearGradient id="person1Gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ec4899" />
          <stop offset="100%" stopColor="#be185d" />
        </linearGradient>

        <linearGradient id="person2Gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#4f46e5" />
        </linearGradient>

        <linearGradient id="person3Gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#10b981" />
          <stop offset="100%" stopColor="#059669" />
        </linearGradient>

        <linearGradient id="connectionGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="100%" stopColor="#3b82f6" />
        </linearGradient>

        <linearGradient id="sendIconGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#10b981" />
          <stop offset="100%" stopColor="#059669" />
        </linearGradient>
      </defs>
    </svg>
  </div>
);
